<app-header1></app-header1>

<!-- Begin page content -->
<div class="wrapper">

  <div class="ace-content container pl-0 pr-0 pb-2">
    <div class="container mb-3 pl-0 pr-0">
      <img class="banner-ace-small" src="/assets/images/ACE-small.png">
    </div>

    <div id="ace-container" class="container mb-2">
      <router-outlet></router-outlet>
    </div>
  </div>

  <div class="push"></div>

</div>


<footer class="footer">
    <span class="text-muted d-none d-sm-block text-center">Copyright ©2017-2023 Consiglio Nazionale delle Ricerche</span>
    <span class="text-muted d-block d-sm-none text-center">Copyright ©2017-2023 CNR</span>
</footer>

<!--<app-feedback></app-feedback>-->

<!--
<body>
<div class="wrapper">

  content

  <div class="push"></div>
</div>
<footer class="footer"></footer>
</body>
-->
